module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_0-9dd4594a1d2d80d707025a4eb1dc5c39.png";